import {
  SelectedCaretakerDetailsDto,
  SelectedCaretakerDetails,
} from '$domain/model/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.model'
import { mapCaretakerQualification } from '$domain/model/nursingHome/nursingHome.mapper'

const getQualification = (selectedCaretakersDetailsDto: SelectedCaretakerDetailsDto) => {
  return {
    qualificationName: selectedCaretakersDetailsDto.qualificationName,
    qualificationType: selectedCaretakersDetailsDto.qualificationType,
    qualificationSpecialty: selectedCaretakersDetailsDto.qualificationSpecialty,
    qualificationArea: selectedCaretakersDetailsDto.qualificationArea,
  }
}

const isAdult = (careTypes: string[]) => careTypes.includes('adult')

const isChild = (careTypes: string[]) => careTypes.includes('child')

const hasExtra = (careTypes: string[]) => careTypes.includes('extra')

export const mapToSelectedCaretakersDetails = (
  selectedCaretakersDetailsDto: SelectedCaretakerDetailsDto[],
): SelectedCaretakerDetails[] => {
  return selectedCaretakersDetailsDto.map(selectedCaretakerDetailsDto => {
    return {
      caretakerId: selectedCaretakerDetailsDto.caretakerId ? selectedCaretakerDetailsDto.caretakerId : '',
      userId: selectedCaretakerDetailsDto.userId ? selectedCaretakerDetailsDto.userId : '',
      caretakerProfileImage: selectedCaretakerDetailsDto.caretakerProfileImage
        ? selectedCaretakerDetailsDto.caretakerProfileImage
        : '',
      name: selectedCaretakerDetailsDto.name ? selectedCaretakerDetailsDto.name : '',
      caretakerHourlyRate: selectedCaretakerDetailsDto.caretakerHourlyRate
        ? selectedCaretakerDetailsDto.caretakerHourlyRate
        : 0,
      qualification: mapCaretakerQualification(getQualification(selectedCaretakerDetailsDto)),
      specialties: selectedCaretakerDetailsDto.specialties ? selectedCaretakerDetailsDto.specialties : [],
      averageRating: selectedCaretakerDetailsDto.averageRating ? selectedCaretakerDetailsDto.averageRating : 0,
      ratingAmount: selectedCaretakerDetailsDto.ratingAmount ? selectedCaretakerDetailsDto.ratingAmount : 0,
      hasActiveProSubscription: selectedCaretakerDetailsDto.hasActiveProSubscription
        ? selectedCaretakerDetailsDto.hasActiveProSubscription
        : false,
      careType: {
        adult: isAdult(selectedCaretakerDetailsDto.careType || []),
        child: isChild(selectedCaretakerDetailsDto.careType || []),
        extra: hasExtra(selectedCaretakerDetailsDto.careType || []),
      },
      isVerified: selectedCaretakerDetailsDto.isVerified ? selectedCaretakerDetailsDto.isVerified : false,
    }
  })
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.mapper.ts